import type { BrandConfig } from '../types';

export const royalx: BrandConfig = {
  id: 'royalx',
  name: 'RoyalX Admin',
  title: 'HeroGames Admin',
  colors: {
    // #FF6B00  ->  hsl(25 100% 50%)
    primaryHsl: '25 100% 50%',
    primary: '#FF6B00',
  },
  assets: {
    logo: '/brands/royalx/logo.png',
    favicon: '/brands/royalx/favicon.ico',
    favicon32: '/brands/royalx/favicon-32x32.png',
    appleTouchIcon: '/brands/royalx/apple-touch-icon.png',
  },
};
